import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineM } from '@sorare/core/src/atoms/typography';

import { GridBackground } from '@sorare/gameplay/src/components/rivals/GridBackground';
import { BackgroundAligned } from '@sorare/gameplay/src/components/rivals/GridBackground/BackgroundAligned';
import { GridDivWithBorder } from '@sorare/gameplay/src/components/rivals/GridBackground/GridDivWithBorder';

const Root = styled(Vertical)`
  height: calc(var(--area-height) - var(--navbar-height-mobile));
  min-height: 200px;
`;
const StyledGridBackground = styled(GridBackground)`
  flex: 1;
`;

type Props = { text: ReactNode };
export const EmptyState = ({ text }: Props) => {
  return (
    <Root>
      <StyledGridBackground intersectionOnCenter height="auto" color="#777777">
        <BackgroundAligned>
          <Vertical gap={2} center>
            <GridDivWithBorder borderColor="var(--c-red-400)">
              <FontAwesomeIcon
                icon={faXmark}
                size="2x"
                color="var(--c-red-400)"
              />
            </GridDivWithBorder>
            <HeadlineM className="text-center">{text}</HeadlineM>
          </Vertical>
        </BackgroundAligned>
      </StyledGridBackground>
    </Root>
  );
};
